var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-breadcrumbs',{attrs:{"items":[
            { text: 'Home', disable: false, href: '/#/' },
            {
                text: 'Growth Tasks',
                disable: false,
                href: '/#/growthtasks'
            },
            { text: _vm.growthTask.rawId, disabled: true }
        ],"divider":"/"}}),_c('GrowthTaskDetailComponent',{attrs:{"growthTaskNodeId":_vm.$route.params.id},on:{"item-fetched":_vm.onGrowthTaskFecthed,"item-deleted":_vm.onGrowthTaskDeleted}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }